import { useEffect, useState } from "react";
import Layout from "@/components/site/Layout";
import PageHero from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { CheckCircle2 } from "lucide-react";
import SafeHtml from "@/components/site/SafeHtml";
import api from "@/lib/api";

export default function About() {
  const [page, setPage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
    api.get("/pages/about").then((r) => { setPage(r.data); document.title = r.data.seo?.title || "About | Labpronics"; }).catch(() => setPage({}));
  }, []);
  if (!page) return <div className="min-h-screen bg-lp-grey" />;
  return (
    <Layout>
      <PageHero eyebrow="About Labpronics" title={page.title || "About Labpronics Technologies"} subtitle={page.intro} image={page.hero_image} />
      <section className="py-20">
        <div className="container-lp max-w-4xl">
          <Reveal><SafeHtml className="prose-lp text-lg" html={page.content || ""} /></Reveal>
          <Reveal delay={0.1}>
            <div className="mt-12 grid sm:grid-cols-3 gap-4">
              {["ISO 27001 Certified", "CMMI Level 3 & 5", "DPIIT Recognised"].map((t) => (
                <div key={t} className="border border-lp-border rounded-sm p-6 text-center hover:border-lp-cyan transition-colors">
                  <CheckCircle2 className="mx-auto text-lp-cyan mb-3" size={26} />
                  <div className="font-600 text-lp-ink">{t}</div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </section>
    </Layout>
  );
}
